export const carouselItems = [
  {
    id: 1,
    title: '《我独自升级》第二季重磅回归',
    tag: '韩漫热载',
    excerpt: '全球累计阅读突破140亿次的超人气韩漫，第二季动画同步热播中，漫画剧情远超动画进度，抢先看完所有高燃名场面。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20dark%20fantasy%20manhwa%20art%20style%2C%20shadow%20warrior%20with%20glowing%20purple%20energy%2C%20dramatic%20lighting%2C%20dynamic%20action%20pose%2C%20intricate%20linework%2C%20cinematic%20composition%2C%20Korean%20webtoon%20illustration%20style%2C%20dark%20background%20with%20particle%20effects&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国民级国漫《斗破苍穹》年番连载突破800话',
    tag: '国漫精品',
    excerpt: '萧炎从废柴少年到炎帝的传奇之路仍在继续，每周稳定双更，下拉式阅读体验让追更更加过瘾，全集免费畅读。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20fantasy%20manhua%20art%2C%20young%20warrior%20with%20flame%20aura%20in%20traditional%20robes%2C%20majestic%20mountain%20landscape%2C%20warm%20golden%20and%20red%20color%20palette%2C%20epic%20scale%2C%20detailed%20Chinese%20ink%20painting%20influence&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '日漫神作《咒术回战》完整汉化版全集上线',
    tag: '日漫经典',
    excerpt: '芥见下下原作的超人气少年漫画，涉谷事变篇全彩精校版现已同步上线本站，支持翻页阅读与弹窗模式自由切换。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20art%20style%2C%20dynamic%20battle%20scene%20with%20cursed%20energy%20effects%2C%20dark%20urban%20fantasy%20setting%2C%20bold%20ink%20lines%2C%20dramatic%20composition%2C%20blue%20and%20black%20energy%20auras%2C%20intense%20action%20pose&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '2026暑期档必追韩漫TOP10专题推荐',
    tag: '编辑精选',
    excerpt: '本季最强追更指南！从都市恋爱到异世界冒险，编辑团队精心挑选十部口碑与热度双爆的新锐韩漫作品合集。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20romance%20fantasy%20webtoon%20collage%20style%2C%20multiple%20characters%20in%20modern%20and%20fantasy%20settings%2C%20soft%20pastel%20color%20palette%2C%20Korean%20digital%20illustration%2C%20warm%20summer%20vibes%2C%20charming%20character%20designs&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '弹窗阅读模式全新升级，追漫体验再进化',
    tag: '功能更新',
    excerpt: '弹窗模式新增智能预加载与自动翻页功能，阅读长条漫时无需手动滑动，沉浸式体验全面对标原生APP，Web端也能畅快追番。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20digital%20reading%20interface%20design%2C%20tablet%20displaying%20colorful%20webtoon%20content%2C%20smooth%20scrolling%20UI%2C%20dark%20mode%20and%20light%20mode%20contrast%2C%20minimalist%20tech%20aesthetic%2C%20warm%20ambient%20lighting&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '国漫之光《镖人》全卷免费用，硬派武侠巅峰',
    tag: '经典重读',
    excerpt: '许先哲创作的硬派历史武侠漫画被誉为"国漫天花板"，本季全卷免费开放阅读，下拉式长条漫完美还原原版大开本阅读体验。',
    image: 'https://readdy.ai/api/search-image?query=Gritty%20historical%20Chinese%20martial%20arts%20manhua%2C%20lone%20swordsman%20in%20desert%20landscape%2C%20ink%20wash%20painting%20style%2C%20bold%20brushstrokes%2C%20dust%20and%20wind%20atmosphere%2C%20dramatic%20silhouette%2C%20Tang%20dynasty%20aesthetic&width=800&height=450&seq=carousel-06&orientation=landscape',
  },
];

export const topicItems = [
  { id: 1, name: '韩漫推荐', heat: '128万讨论', color: 'accent' as const },
  { id: 2, name: '下拉式阅读', heat: '96万讨论', color: 'primary' as const },
  { id: 3, name: '国漫崛起', heat: '87万讨论', color: 'secondary' as const },
  { id: 4, name: '日漫新番', heat: '74万讨论', color: 'accent' as const },
  { id: 5, name: '免费全集', heat: '65万讨论', color: 'primary' as const },
  { id: 6, name: '弹窗模式', heat: '53万讨论', color: 'secondary' as const },
  { id: 7, name: '恋爱韩漫', heat: '48万讨论', color: 'accent' as const },
  { id: 8, name: '翻页阅读', heat: '42万讨论', color: 'primary' as const },
  { id: 9, name: '热血日漫', heat: '39万讨论', color: 'secondary' as const },
  { id: 10, name: '武侠国漫', heat: '35万讨论', color: 'accent' as const },
];

export const rankingItems = [
  {
    id: 1,
    rank: 1,
    title: '我独自升级',
    tag: '韩漫',
    heat: '周阅读量 2,380万',
    update: '今日更新 第201话',
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20manhwa%20cover%20art%2C%20shadow%20warrior%20silhouette%20with%20glowing%20eyes%2C%20purple%20and%20black%20color%20scheme%2C%20Korean%20webtoon%20vertical%20cover%20style%2C%20dramatic%20lighting&width=200&height=280&seq=rank-01&orientation=portrait',
  },
  {
    id: 2,
    rank: 2,
    title: '斗破苍穹',
    tag: '国漫',
    heat: '周阅读量 1,950万',
    update: '今日更新 第812话',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20art%2C%20young%20cultivator%20with%20flame%20powers%2C%20golden%20and%20red%20aesthetic%2C%20epic%20vertical%20composition%2C%20traditional%20Chinese%20elements&width=200&height=280&seq=rank-02&orientation=portrait',
  },
  {
    id: 3,
    rank: 3,
    title: '咒术回战',
    tag: '日漫',
    heat: '周阅读量 1,720万',
    update: '昨日更新 第271话',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20cover%20style%2C%20dark%20sorcerer%20character%20with%20tattoos%2C%20blue%20cursed%20energy%20effects%2C%20bold%20graphic%20design%2C%20vertical%20composition&width=200&height=280&seq=rank-03&orientation=portrait',
  },
  {
    id: 4,
    rank: 4,
    title: '某天成为公主',
    tag: '韩漫',
    heat: '周阅读量 1,480万',
    update: '今日更新 第156话',
    image: 'https://readdy.ai/api/search-image?query=Romance%20fantasy%20webtoon%20cover%20art%2C%20beautiful%20princess%20in%20elegant%20gown%2C%20soft%20pink%20and%20gold%20color%20palette%2C%20Korean%20digital%20illustration%2C%20vertical%20portrait%20style&width=200&height=280&seq=rank-04&orientation=portrait',
  },
  {
    id: 5,
    rank: 5,
    title: '镖人',
    tag: '国漫',
    heat: '周阅读量 1,260万',
    update: '本周更新 第118话',
    image: 'https://readdy.ai/api/search-image?query=Gritty%20historical%20manhua%20cover%20art%2C%20lone%20warrior%20in%20desert%2C%20ink%20brush%20style%2C%20bold%20monochrome%20with%20red%20accents%2C%20Tang%20dynasty%20aesthetic%2C%20vertical%20portrait&width=200&height=280&seq=rank-05&orientation=portrait',
  },
];

export const indexItems = [
  {
    id: 1,
    title: '韩漫殿堂',
    desc: '精选高品质韩漫，从热血升级到浪漫恋爱全覆盖',
    count: '2,860部',
    icon: 'ri-global-fill',
  },
  {
    id: 2,
    title: '日漫经典',
    desc: '少年Jump、Magazine等名作汉化全集在线看',
    count: '4,120部',
    icon: 'ri-earth-fill',
  },
  {
    id: 3,
    title: '国漫之光',
    desc: '腾讯动漫、快看等平台热门国漫同步追更',
    count: '1,950部',
    icon: 'ri-star-fill',
  },
  {
    id: 4,
    title: '下拉式专区',
    desc: '适配长条漫阅读习惯，一滑到底的沉浸体验',
    count: '5,300部',
    icon: 'ri-scroll-to-bottom-fill',
  },
  {
    id: 5,
    title: '翻页经典',
    desc: '传统日漫翻页模式，左右翻页还原纸质书手感',
    count: '3,440部',
    icon: 'ri-book-open-fill',
  },
  {
    id: 6,
    title: '弹窗新番',
    desc: '弹窗式逐格阅读，专注每一格画面细节呈现',
    count: '1,870部',
    icon: 'ri-window-fill',
  },
  {
    id: 7,
    title: '完结全集',
    desc: '全部已完结作品免费看，一口气追到结局',
    count: '6,280部',
    icon: 'ri-check-double-fill',
  },
];

export const featuresItems = [
  {
    id: 1,
    title: '三种阅读模式随心切换',
    desc: '下拉式、翻页和弹窗三种阅读模式，适配不同类型漫画的最佳阅读体验。长条韩漫用下拉式一气呵成，经典日漫用翻页模式还原纸质手感，弹窗模式逐格精读不错过任何细节。',
    icon: 'ri-layout-row-fill',
  },
  {
    id: 2,
    title: '海量高清资源每日更新',
    desc: '收录超过15,000部漫画作品，涵盖韩漫、日漫、国漫三大品类。每日同步更新最新章节，热门作品上线24小时内即可在本站阅读，绝不让你落后追更进度。',
    icon: 'ri-database-2-fill',
  },
  {
    id: 3,
    title: '全平台流畅在线阅读',
    desc: '无需下载APP，浏览器打开即可畅读。智能预加载技术保障翻页零延迟，自适应排版适配手机、平板和电脑屏幕，WiFi和移动网络下均可流畅阅读全集漫画。',
    icon: 'ri-device-line',
  },
];

export const appItem = {
  title: '手机阅读更便捷',
  desc: '将香蕉文化漫画添加到手机桌面，即可获得类APP的沉浸式阅读体验。支持PWA离线缓存，通勤路上也能畅快追漫。',
  tips: 'Safari/Chrome 浏览器菜单中选择"添加到主屏幕"即可',
};

export const contactItem = {
  title: '投稿与合作',
  desc: '欢迎漫画作者、汉化组、版权方与我们联系。香蕉文化漫画网致力于为漫画爱好者提供优质的在线阅读平台，期待与更多优秀创作者携手合作，共同丰富漫画资源生态。',
  email: 'contact@bananacomic.example.com',
  qq: '100000000',
};

export const mediaItems = [
  {
    id: 1,
    title: '【韩漫推荐】2026年最值得追的十部新作',
    desc: '从奇幻冒险到都市恋爱，编辑精选本年度韩漫新番推荐，下拉式阅读体验最佳搭配。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thumbnail%20style%20collage%2C%20multiple%20character%20portraits%20in%20various%20art%20styles%2C%20colorful%20vibrant%20composition%2C%20play%20button%20overlay%2C%20YouTube%20style%20thumbnail%20design&width=640&height=360&seq=media-01&orientation=landscape',
    duration: '12:38',
  },
  {
    id: 2,
    title: '【阅读指南】三种阅读模式怎么选？一篇文章教会你',
    desc: '下拉式、翻页和弹窗模式各有适合的漫画类型和使用场景，看完这篇你也能选出最舒适的阅读方式。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20tutorial%20style%20thumbnail%2C%20split%20screen%20showing%20three%20different%20reading%20modes%20on%20mobile%20device%2C%20modern%20UI%20design%2C%20warm%20friendly%20tone&width=640&height=360&seq=media-02&orientation=landscape',
    duration: '08:15',
  },
  {
    id: 3,
    title: '【国漫崛起】从《镖人》到《一人之下》，国漫这十年',
    desc: '盘点十年来国漫从模仿到创新的发展历程，那些让我们为之骄傲的国漫代表作品回顾。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20documentary%20style%20thumbnail%2C%20timeline%20evolution%20of%20Chinese%20comics%2C%20ink%20painting%20to%20digital%20transition%2C%20warm%20nostalgic%20tone&width=640&height=360&seq=media-03&orientation=landscape',
    duration: '18:42',
  },
  {
    id: 4,
    title: '【日漫新番】Jump系2026夏季连载阵容全解析',
    desc: '周刊少年Jump最新连载作品大盘点，哪些新作值得追？老牌作品又有哪些新动向？一次性告诉你。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20magazine%20style%20thumbnail%2C%20collage%20of%20shonen%20manga%20characters%2C%20bold%20graphic%20design%2C%20red%20and%20black%20color%20scheme%2C%20energetic%20composition&width=640&height=360&seq=media-04&orientation=landscape',
    duration: '15:20',
  },
];

export const aboutItem = {
  title: '关于香蕉文化漫画',
  paragraphs: [
    '香蕉文化漫画网创立于2018年，是国内领先的漫画在线阅读平台之一。我们致力于为漫画爱好者提供最优质的在线阅读体验，收录超过15,000部韩漫、日漫和国漫作品，涵盖热血、恋爱、奇幻、武侠、悬疑等全部主流题材。',
    '平台独创下拉式、翻页和弹窗三种阅读模式，用户可根据不同漫画类型和个人偏好自由切换。下拉式适配韩漫长条格式，一气呵成不中断；翻页模式还原纸质书阅读体验，适合传统日漫；弹窗模式逐格精读，不放过每一处画面细节。',
    '我们的内容团队每日追踪全球漫画更新动态，确保热门作品第一时间同步上线。所有漫画均为正版授权或汉化组授权发布，为用户提供安全、流畅、高质量的在线阅读服务。',
  ],
  stats: [
    { value: '15,000+', label: '漫画资源' },
    { value: '860万', label: '月活读者' },
    { value: '3种', label: '阅读模式' },
    { value: '99.9%', label: '服务在线率' },
  ],
};

export const updatesItems = [
  {
    id: 1,
    date: '2026-07-27',
    title: '《我独自升级》第二季漫画第202话提前上线',
    desc: '应读者强烈要求，编辑团队加班完成最新话汉化校对，比预定时间提前12小时发布。',
  },
  {
    id: 2,
    date: '2026-07-25',
    title: '弹窗阅读模式智能预加载功能全量上线',
    desc: '弹窗模式下新增AI预判翻页功能，根据阅读速度自动预加载后续内容，大幅减少等待时间。',
  },
  {
    id: 3,
    date: '2026-07-20',
    title: '暑期韩漫专区新增300+部热门作品',
    desc: '一次性更新300余部韩漫资源，涵盖都市恋爱、异世界、重生等多种热门题材，下拉式阅读体验全面优化。',
  },
  {
    id: 4,
    date: '2026-07-15',
    title: '「国漫之光」专题页面上线，《镖人》全卷免费开放',
    desc: '为庆祝国漫近年来取得的成就，特别策划国漫之光专题，许先哲代表作《镖人》全卷限时免费阅读。',
  },
  {
    id: 5,
    date: '2026-07-10',
    title: '翻页阅读模式新增左右手切换和缩放功能',
    desc: '根据读者反馈，翻页模式新增左手模式支持和两指缩放功能，大屏设备阅读体验更上一层楼。',
  },
  {
    id: 6,
    date: '2026-07-05',
    title: '服务器全面升级，全站加载速度提升40%',
    desc: '完成CDN节点扩容和服务器架构优化，全国范围内漫画图片加载速度大幅提升，移动网络下也可流畅阅读。',
  },
  {
    id: 7,
    date: '2026-06-28',
    title: '2026夏季日漫新番专题上线，Jump系全收录',
    desc: '周刊少年Jump、Magazine等主流杂志的夏季新连载全部收录，汉化版本持续更新中。',
  },
  {
    id: 8,
    date: '2026-06-20',
    title: '手机端PWA支持上线，桌面添加即享APP体验',
    desc: '支持iOS和Android设备添加至主屏幕，离线缓存功能让通勤追漫不再依赖网络信号。',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '香蕉文化漫画网上的漫画都是免费的吗？',
    answer: '是的，本站所有漫画作品均免费提供在线阅读。我们通过广告和合作授权模式维持运营，读者无需付费即可畅享海量韩漫、日漫和国漫资源。部分热门作品的抢先看章节同样免费开放。',
  },
  {
    id: 2,
    question: '三种阅读模式分别适合什么类型的漫画？',
    answer: '下拉式最适合韩漫长条格式，上下滑动即可连续阅读，一气呵成；翻页模式适合传统日漫，左右翻页还原纸质书阅读手感；弹窗模式适合需要逐格精读的作品，点击弹窗逐格显示画面细节。您可以在阅读页面右上角随时切换。',
  },
  {
    id: 3,
    question: '需要下载APP或注册账号才能看漫画吗？',
    answer: '完全不需要。香蕉文化漫画网是纯网页端在线阅读平台，打开浏览器即可直接阅读，无需下载任何APP或注册账号。不过注册账号后可以收藏作品和同步阅读进度，推荐有追漫需求的读者使用。',
  },
  {
    id: 4,
    question: '漫画更新频率如何？热门作品多久更新一次？',
    answer: '我们与各大漫画平台和汉化组保持同步更新。日漫通常在原版发布后24-48小时内上线汉化版；韩漫热门作品每周更新1-2话；国漫热门年番作品基本保持每周稳定更新。所有更新动态可在"最新动态"模块查看。',
  },
  {
    id: 5,
    question: '手机上阅读漫画的体验如何？支持哪些浏览器？',
    answer: '本站针对移动端进行了深度优化，支持Safari、Chrome、Edge等主流浏览器。下拉式模式在手机上尤为流畅，配合PWA功能可将网站添加到手机桌面获得类APP体验。移动网络下也做了图片压缩优化，流量消耗可控。',
  },
];

export const cardsItems = [
  {
    id: 1,
    title: '全知读者视角',
    tag: '韩漫·奇幻',
    excerpt: '唯一读完末日小说的人，在小说变成现实的瞬间获得了预知一切的绝对优势。下拉式阅读完美适配这部超长叙事韩漫。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20card%20art%2C%20mysterious%20protagonist%20in%20modern%20apocalyptic%20setting%2C%20glowing%20book%20motif%2C%20dramatic%20composition%2C%20cool%20blue%20and%20silver%20color%20palette&width=400&height=520&seq=card-01&orientation=portrait',
  },
  {
    id: 2,
    title: '一人之下',
    tag: '国漫·异能',
    excerpt: '米二创作的超人气异能漫画，融合道家文化与现代都市的独特世界观。翻页模式完美还原大开本漫画的视觉冲击力。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manhua%20card%20art%2C%20young%20man%20with%20mysterious%20energy%20powers%2C%20traditional%20Taoist%20elements%2C%20urban%20setting%2C%20dynamic%20action%20pose&width=400&height=520&seq=card-02&orientation=portrait',
  },
  {
    id: 3,
    title: '间谍过家家',
    tag: '日漫·喜剧',
    excerpt: '远藤达哉的现象级喜剧漫画，间谍父亲、杀手母亲、读心女儿组成的伪装家庭温馨又爆笑。弹窗模式逐格品味每个笑点。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20comedy%20manga%20card%20art%2C%20family%20of%20three%20in%20stylish%20outfits%2C%20spy%20theme%20with%20warm%20family%20comedy%20tone%2C%20clean%20linework%2C%20pastel%20color%20palette&width=400&height=520&seq=card-03&orientation=portrait',
  },
  {
    id: 4,
    title: '剑尊归来',
    tag: '韩漫·武侠',
    excerpt: '前世天下第一剑尊重生归来，以碾压之姿重整武林秩序的复仇爽漫。下拉式长条格式完美呈现精彩打斗分镜。',
    image: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20webtoon%20card%2C%20swordmaster%20with%20flowing%20robes%20in%20dramatic%20pose%2C%20moonlight%20background%2C%20elegant%20and%20powerful%20character%20design&width=400&height=520&seq=card-04&orientation=portrait',
  },
  {
    id: 5,
    title: '完美世界',
    tag: '国漫·玄幻',
    excerpt: '辰东原作改编的超高人气玄幻国漫，石昊从大荒走出的称帝之路。年番连载超400话，全程免费全集追更。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20xuanhuan%20manhua%20card%20art%2C%20young%20warrior%20in%20ancient%20fantasy%20world%2C%20celestial%20beasts%20and%20magical%20effects%2C%20epic%20fantasy%20atmosphere%2C%20golden%20light&width=400&height=520&seq=card-05&orientation=portrait',
  },
  {
    id: 6,
    title: '葬送的芙莉莲',
    tag: '日漫·奇幻',
    excerpt: '勇者小队击败魔王之后，长生种精灵魔法使芙莉莲的悠长旅程。翻页模式最适合沉浸于这部治愈又感伤的奇幻名作。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20manga%20card%20art%2C%20elf%20mage%20in%20peaceful%20journey%2C%20beautiful%20pastoral%20fantasy%20landscape%2C%20gentle%20and%20melancholic%20atmosphere%2C%20soft%20watercolor%20style&width=400&height=520&seq=card-06&orientation=portrait',
  },
  {
    id: 7,
    title: '传武',
    tag: '国漫·恐怖',
    excerpt: '以中国传统民俗和恐怖传说为蓝本的暗黑国漫，画风硬核，剧情烧脑。弹窗模式逐格放大的压迫感令人头皮发麻。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20manhua%20card%20art%2C%20dark%20supernatural%20atmosphere%2C%20traditional%20folk%20horror%20elements%2C%20detailed%20ink%20brushwork%2C%20ominous%20red%20and%20black%20color%20scheme&width=400&height=520&seq=card-07&orientation=portrait',
  },
];

export const commentsItems = [
  {
    id: 1,
    name: '追漫达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20character%20avatar%2C%20friendly%20expression%2C%20simple%20background%2C%20clean%20digital%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2026-07-26',
    content: '从大学开始就在香蕉文化看漫画了，下拉式阅读是真的爽，手机上一滑到底完全不用点翻页按钮。韩漫和国漫资源也很全，最近《我独自升级》第二季看得根本停不下来！',
    tag: '老读者',
  },
  {
    id: 2,
    name: '二次元少女小樱',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20female%20character%20avatar%2C%20cute%20expression%2C%20pink%20hair%2C%20simple%20background%2C%20clean%20digital%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '2026-07-24',
    content: '三种阅读模式这个设计太贴心了！看日漫用翻页模式有看实体书的感觉，看韩漫换下拉式一口气追几十话，最近弹窗模式看细节也超好用。强烈安利给所有漫画爱好者！',
    tag: '漫画达人',
  },
  {
    id: 3,
    name: '夜猫子读者老陈',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20mature%20male%20character%20avatar%2C%20calm%20expression%2C%20glasses%2C%20simple%20background%2C%20clean%20digital%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '2026-07-22',
    content: '作为看了二十年漫画的老读者，香蕉文化的日漫汉化质量和更新速度真的让人惊喜。国漫专区也做得越来越好，《一人之下》和《镖人》的翻页体验比很多付费平台都好，真心推荐。',
    tag: '资深读者',
  },
];

export const heroStats = [
  { label: '漫画资源', value: '15,000+' },
  { label: '日更新量', value: '200+' },
  { label: '阅读模式', value: '3种' },
];

export const siteInfo = {
  name: '香蕉文化漫画',
  fullName: '香蕉文化漫画网',
  slogan: '下拉式·翻页·弹窗 — 你的全能漫画阅读伙伴',
  intro: '香蕉文化漫画网是国内领先的漫画在线阅读平台，专注为漫画爱好者提供最优质的免费全集阅读体验。平台独创下拉式、翻页与弹窗三种阅读模式，收录超过15,000部韩漫、日漫和国漫精品资源。无论你是热爱热血升级的韩漫迷、钟情Jump系经典的日漫粉，还是支持国产原创的国漫读者，都能在这里找到属于自己的阅读节奏。每日更新200+章节，热门作品一键追更，无需下载APP，浏览器打开即可畅享流畅在线阅读。',
};